import { render, staticRenderFns } from "./FormProduct.vue?vue&type=template&id=afacd8a6&scoped=true"
import script from "./FormProduct.vue?vue&type=script&lang=js"
export * from "./FormProduct.vue?vue&type=script&lang=js"
import style0 from "./FormProduct.vue?vue&type=style&index=0&id=afacd8a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afacd8a6",
  null
  
)

export default component.exports